import BaseModel from "@/api/models/BaseModel";

/**
 * PaymentStatusDictionary
 */
export default class StudentDictionary extends BaseModel {
    
    constructor() {
        super();

        this.ACTIVE = 1;
        this.INACTIVE = 2;
    }
}